import { RtCarrierNumberRouter } from 'RtUi/app/rtCarrierConnect/Numbers/RtCarrierNumber.router';
import { DidNumberProfileContainerClass } from 'RtUi/app/rtDid/Numbers/DidNumber.profile';

@RtCarrierNumberRouter.getProfileRtUiController()
export class RtCarrierNumberProfileContainer extends DidNumberProfileContainerClass {
	protected router = RtCarrierNumberRouter;
}
